<template>
  <div class="sensor-list">
    <div class="sensor-list-item common-border" v-for="(item, index) in processedList" :key="index">
      <div class="sensor-list-item-name">
        <span>{{ item.showName || item.name }}</span>
        <i
          class="el-icon-message-solid"
          style="color: #ff3c3b; margin-left: 5px"
          v-if="item.alarmState && item.alarmState !== 0"
        ></i>
      </div>
      <div
        class="sensor-list-item-value"
        v-if="item.name == 'pm1' || item.name == 'pm25'"
        :style="{
          color: item.color
        }"
      >
        {{ item.displayValue }}
      </div>
      <div class="sensor-list-item-value" v-else :class="'value' + item.alarmState">
        {{ item.displayValue }}
      </div>
      <div class="sensor-list-item-unit">{{ item.unitName }}</div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    list: {
      type: Array,
      default: () => []
    }
  },
  computed: {
    processedList() {
      return this.list.map(item => ({
        ...item,
        displayValue: item.value || '0' // 添加默认值处理
      }));
    }
  },

  data() {
    return {};
  },
  methods: {},
  components: {}
};
</script>

<style scoped lang="scss">
.sensor-list {
  padding: 10px;
  box-sizing: border-box;
  display: grid;
  grid-template-columns: repeat(6, 1fr);
  grid-gap: 20px;
  .sensor-list-item {
    padding: 10px;
    box-sizing: border-box;
    text-align: center;

    height: 120px;
    // border: 2px solid #04f3f2;
    border: 1px solid rgb(96, 118, 173);
    &-name,
    &-unit {
      font-size: 18px;
    }
    &-value {
      font-size: 22px;
      font-weight: bold;
    }
    .value0 {
      color: #00e401;
    }
    .value1 {
      color: #f8d51f;
    }
    .value2 {
      color: #ff3c3b;
    }
    .value3 {
      color: #ff7e01;
    }
    &:hover {
      background-color: var(--drone-sensor-bg-hover-color);
    }
  }
}
</style>
